/**
 * Lodifarma Theme Base JavaScript
 */

document.addEventListener('DOMContentLoaded', () => {
  initScrollReveal();
  initSearchPlaceholder();
  initPredictiveSearch();
  initAjaxCart();
});

document.addEventListener('shopify:section:load', () => {
  initScrollReveal();
  initPredictiveSearch();
  initAjaxCart();
});

/**
 * 1. Scroll Reveal Animation
 */
function initScrollReveal() {
  const revealElements = document.querySelectorAll('.section-reveal');
  
  const observerOptions = {
    root: null,
    rootMargin: '100px 0px 100px 0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  revealElements.forEach(el => {
    observer.observe(el);
  });
}

/**
 * 2. Search Bar Placeholder Animation
 */
function initSearchPlaceholder() {
  const searchInput = document.querySelector('.js-search-input');
  if (!searchInput) return;

  const placeholders = [
    "Busca 'Paclitaxel'",
    "Busca 'Rituximab'",
    "Busca 'Cisplatino'",
    "Busca 'Bortezomib'",
    "Busca por principio activo..."
  ];
  
  let currentIndex = 0;

  setInterval(() => {
    searchInput.classList.add('fade-placeholder');
    setTimeout(() => {
      currentIndex = (currentIndex + 1) % placeholders.length;
      searchInput.setAttribute('placeholder', placeholders[currentIndex]);
      searchInput.classList.remove('fade-placeholder');
    }, 300);
  }, 3000);
}

/**
 * 3. Predictive Search
 */
function initPredictiveSearch() {
  const forms = document.querySelectorAll('form[action*="/search"]');
  
  forms.forEach(form => {
    const input = form.querySelector('input[name="q"]');
    if (!input) return;
    
    let resultsContainer = form.querySelector('.predictive-search-results');
    if (!resultsContainer) {
      resultsContainer = document.createElement('div');
      resultsContainer.className = 'predictive-search-results';
      form.appendChild(resultsContainer);
    }

    let debounceTimer;

    input.addEventListener('input', (e) => {
      clearTimeout(debounceTimer);
      const query = e.target.value.trim();
      
      if (query.length < 1) {
        resultsContainer.innerHTML = '';
        resultsContainer.classList.remove('is-active');
        return;
      }

      debounceTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`)
          .then(response => response.json())
          .then(data => {
            const products = data.resources.results.products;
            if (products && products.length > 0) {
              const html = products.map(p => {
                const imgUrl = p.featured_image && p.featured_image.url
                  ? p.featured_image.url.split('?')[0] + '?width=96'
                  : null;
                const imgHtml = imgUrl
                  ? `<img src="${imgUrl}" alt="${p.title}">`
                  : '<div class="predictive-placeholder"><i class="ph ph-pill"></i></div>';
                const priceStr = p.price
                  ? '$' + (p.price / 100).toLocaleString('es-MX', { minimumFractionDigits: 2 }) + ' MXN'
                  : '';
                return `
                  <a href="${p.url}" class="predictive-result-item">
                    ${imgHtml}
                    <div class="predictive-info">
                      <span class="predictive-title">${p.title}</span>
                      ${priceStr ? `<span class="predictive-price">${priceStr}</span>` : ''}
                    </div>
                  </a>
                `;
              }).join('');

              const allResultsUrl = `/search?q=${encodeURIComponent(query)}&type=product`;
              resultsContainer.innerHTML = `${html}<a href="${allResultsUrl}" class="predictive-view-all">Ver todos los resultados <i class="ph ph-arrow-right"></i></a>`;
              resultsContainer.classList.add('is-active');
            } else {
              resultsContainer.innerHTML = `<div class="predictive-empty">Sin resultados para "${query}"</div>`;
              resultsContainer.classList.add('is-active');
            }
          })
          .catch(err => console.error('Predictive search error:', err));
      }, 300);
    });

    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) {
        resultsContainer.classList.remove('is-active');
      }
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 1 && resultsContainer.children.length > 0) {
        resultsContainer.classList.add('is-active');
      }
    });
  });
}

/**
 * 4. AJAX Cart & Dynamic Drawer
 */
function initAjaxCart() {
  document.addEventListener('submit', function(e) {
    const form = e.target;
    // Intercept forms submitting to cart/add
    if (form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
      e.preventDefault();
      
      const submitBtn = form.querySelector('[type="submit"]');
      if(submitBtn) {
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.innerHTML = 'Agregando...';
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
      .then(response => response.json())
      .then(() => {
        // Fetch current page again to get updated Cart Drawer HTML
        return fetch(window.location.href);
      })
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Update Drawer Content
        const newDrawerContent = doc.querySelector('#CartDrawer .cart-drawer__content');
        if (newDrawerContent) {
          document.querySelector('#CartDrawer .cart-drawer__content').innerHTML = newDrawerContent.innerHTML;
        }
        
        // Update Cart Counts globally
        const newCartCount = doc.querySelector('.cart-count');
        if (newCartCount) {
          document.querySelectorAll('.cart-count').forEach(el => el.innerHTML = newCartCount.innerHTML);
        }

        // Reset Button
        if(submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.innerHTML = 'Agregado ✓';
          setTimeout(() => submitBtn.innerHTML = 'Agregar al carrito', 2000);
        }

        // Open Drawer
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer();
        }
      })
      .catch(err => {
        console.error('Ajax Cart Error:', err);
        if(submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.innerHTML = 'Error al agregar';
        }
      });
    }
  });
}

/**
 * Update Cart Quantity from Drawer
 */
window.updateCartQuantity = function(line, qty) {
  // Add loading state to drawer
  const drawerContent = document.querySelector('.cart-drawer__content');
  if(drawerContent) drawerContent.style.opacity = '0.5';

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: qty })
  })
  .then(res => res.json())
  .then(() => {
    // Fetch updated HTML
    return fetch(window.location.href);
  })
  .then(res => res.text())
  .then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Update Drawer Content
    const newDrawerContent = doc.querySelector('#CartDrawer .cart-drawer__content');
    if (newDrawerContent) {
      document.querySelector('#CartDrawer .cart-drawer__content').innerHTML = newDrawerContent.innerHTML;
    }
    if(drawerContent) drawerContent.style.opacity = '1';
    
    // Update Cart Counts
    const newCartCount = doc.querySelector('.cart-count');
    if (newCartCount) {
      document.querySelectorAll('.cart-count').forEach(el => el.innerHTML = newCartCount.innerHTML);
    }
  })
  .catch(err => {
    console.error('Update Cart Error:', err);
    if(drawerContent) drawerContent.style.opacity = '1';
  });
};
